import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Project, ProjectsState } from "../types/project";

const initialState: ProjectsState = {
  value: [],
};

export const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setProjects: (state, action: PayloadAction<Project[]>) => {
      state.value = action.payload || [];
    },
    updateProjects: (state, action: PayloadAction<Record<string, Project>>) => {
      const existingIds = state.value.map((project) => project.id);
      Object.values(action.payload).forEach((project) => {
        if (!existingIds.includes(project.id)) {
          state.value.push(project);
        }
      });
    },
    addProject: (state, action: PayloadAction<Project>) => {
      state.value.push(action.payload);
    },
    removeProject: (state, action: PayloadAction<string | number>) => {
      state.value = state.value.filter((p) => p.id !== action.payload);
    },
  },
});

export const { setProjects, updateProjects, addProject, removeProject } =
  projectSlice.actions;
export default projectSlice.reducer;
